import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import "./AuctionSimulationLux.css";

const AuctionSimulationLux = () => {
  const navigate = useNavigate();
  const [currentPrice, setCurrentPrice] = useState(12700);
  const [timeLeft, setTimeLeft] = useState(45);
  const [bidAmount, setBidAmount] = useState(12900);
  const [bids, setBids] = useState([
    { user: "Usuario_C", amount: 12700, time: "Ha 15s" },
    { user: "Bruno_88", amount: 12400, time: "Ha 45s" },
    { user: "Voce", amount: 12100, time: "Ha 1m" },
    { user: "Carla_M", amount: 11800, time: "Ha 1m 20s" },
  ]);
  const [isEnded, setIsEnded] = useState(false);
  const timerRef = useRef(null);

  const formatCurrency = (value) =>
    value.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });

  useEffect(() => {
    timerRef.current = setInterval(() => {
      setTimeLeft((prev) => {
        if (prev <= 0) {
          clearInterval(timerRef.current);
          setIsEnded(true);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(timerRef.current);
  }, []);

  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60).toString().padStart(2, "0");
    const secs = (seconds % 60).toString().padStart(2, "0");
    return `${mins}:${secs}`;
  };

  const simulateCompetitorBid = () => {
    if (isEnded) return;
    setCurrentPrice((prevPrice) => {
      const newPrice = prevPrice + 200;
      const competitors = ["Ana_L", "Pedro_Invest", "Colecionador_SP", "Mari_Bolsas"];
      const randomUser = competitors[Math.floor(Math.random() * competitors.length)];
      setBids((prev) => [{ user: randomUser, amount: newPrice, time: "Agora", isNew: true }, ...prev]);
      setBidAmount(newPrice + 200);
      return newPrice;
    });
    setTimeLeft((prev) => (prev < 30 ? 30 : prev));
  };

  const placeBid = () => {
    if (bidAmount > currentPrice) {
      const newPrice = bidAmount;
      setCurrentPrice(newPrice);
      setBids((prev) => [{ user: "Voce", amount: newPrice, time: "Agora", isNew: true }, ...prev]);
      if (timeLeft < 30) setTimeLeft(30);
      setBidAmount(newPrice + 200);
      setTimeout(simulateCompetitorBid, 3000 + Math.random() * 2000);
    } else {
      alert("O lance deve ser maior que o valor atual!");
    }
  };

  return (
    <div className="asim-lux-root">
      <div className="asim-lux-shell">
        <button className="asim-lux-back" onClick={() => navigate("/auctions")}>
          <FontAwesomeIcon icon={faArrowLeft} />
          Voltar para Leiloes
        </button>

        {/* Image */}
        <div className="asim-lux-img-wrap">
          <div className="asim-lux-live">
            <div className="asim-lux-live-dot" />
            AO VIVO
          </div>
          <img
            src="/auctions/gucci-marmont.jpg"
            alt="Bolsa Gucci Marmont Preta"
            loading="eager"
          />
        </div>

        {/* Details */}
        <div className="asim-lux-details">
          <span className="asim-lux-lot">Lote #102 &bull; Bolsas de Luxo</span>
          <h1>Gucci GG Marmont Small Matelasse</h1>
          <p className="asim-lux-desc">
            Bolsa de ombro GG Marmont pequena em couro matelasse preto com
            ferragens em tom dourado antigo.
            <br />
            <strong>Condicao:</strong> Excelente (com dustbag original).
            <br />
            <strong>Valor de Mercado:</strong> R$ 13.320,00
          </p>

          {/* Bid Box */}
          <div className="asim-lux-bid-box">
            <p className="asim-lux-bid-label">Lance Atual</p>
            <p className="asim-lux-bid-price">{formatCurrency(currentPrice)}</p>
            <div
              className={`asim-lux-timer ${timeLeft < 10 ? "asim-lux-timer--warn" : "asim-lux-timer--normal"}`}
            >
              <span>Fecha em:</span>
              <span>{isEnded ? "ENCERRADO" : formatTime(timeLeft)}</span>
            </div>
          </div>

          {/* History */}
          <div className="asim-lux-history">
            {bids.map((bid, index) => (
              <div
                key={index}
                className={`asim-lux-bid-row ${bid.isNew ? "new" : ""}`}
              >
                <span className="asim-lux-bid-user">{bid.user}</span>
                <span className="asim-lux-bid-amount">
                  {formatCurrency(bid.amount)}
                </span>
                <span className="asim-lux-bid-time">{bid.time}</span>
              </div>
            ))}
          </div>

          {/* Action */}
          <div className="asim-lux-action">
            <input
              type="number"
              className="asim-lux-input"
              value={bidAmount}
              onChange={(e) => setBidAmount(parseInt(e.target.value))}
              disabled={isEnded}
            />
            <button
              className="asim-lux-bid-btn"
              onClick={placeBid}
              disabled={isEnded}
            >
              {isEnded ? "Leilao Finalizado" : "Dar Lance"}
            </button>
          </div>

          <p className="asim-lux-fee">
            +5% de taxa do leiloeiro sobre o valor final.
          </p>
        </div>
      </div>
    </div>
  );
};

export default AuctionSimulationLux;
